import Picker from './picker.vue'
export type { PickerProps } from './props'
export default Picker